import { StickableUIData } from "./stickableUIData";

export class TabsUIData extends StickableUIData {
   
 

}